import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import AccountsIndexCard from '../../Accounts/AccountsIndexCard';

export default function AccountsPage(props) {
	// console.log('Accounts List Page', props);
	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.accounts')}
				category={I18n.t('admin.accounts')}
			/>
			<AccountsIndexCard
				permissionsHelper={props.permissionsHelper}
				public_id={props.public_id}
				accounts_list_endpoint={props.accounts_list_endpoint}
				get_account_endpoint={props.get_account_endpoint}
				update_account_endpoint={props.update_account_endpoint}
				iam_account_create_endpoint={props.iam_account_create_endpoint}
				account_crud_api_key={props.account_crud_api_key}
			/>
		</div>
	);
}
